/* eslint-disable no-unused-vars */
import { Link, useNavigate } from 'react-router-dom'
import Divider from '../../../../../components/Divider'
import ArrowRightIcon from '../../../../../icons/ArrowRightIcon'
import CheckIcon from '../../../../../icons/landing/CheckIcon'
import OpenTabIcon from '../../../../../icons/OpenTabIcon'
import Button from '../../../../../components/Button'
import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateTalentStatusHutritClub } from '../../../../../services/HutritClub'
import Loader from '../../../../../components/Loader'
import Toast from '../../../../../components/Toast/Toast'
import Xicon from '../../../../../icons/filters/Xicon'
import {
  IS_ADMIN,
  IS_COMPANY,
  NOT_AVAILABLE,
  OUT_OF_THE_APP,
} from '../../../../../utils/constants'
import Badge from '../../../../../components/Badge/Badge'
import { copyClipboard, openNewTab } from '../../../../../utils'
import { useState } from 'react'
//import StarRating from '../../../../../components/StartRating'

export const shareIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <mask
      id="mask0_1246_3464"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1246_3464)">
      <path
        d="M12 14.6668C11.4444 14.6668 10.9722 14.4724 10.5833 14.0835C10.1944 13.6946 10 13.2224 10 12.6668C10 12.5891 10.0056 12.5085 10.0167 12.4252C10.0278 12.3418 10.0444 12.2668 10.0667 12.2002L5.36667 9.46683C5.17778 9.6335 4.96667 9.76405 4.73333 9.8585C4.5 9.95294 4.25556 10.0002 4 10.0002C3.44444 10.0002 2.97222 9.80572 2.58333 9.41683C2.19444 9.02794 2 8.55572 2 8.00016C2 7.44461 2.19444 6.97239 2.58333 6.5835C2.97222 6.19461 3.44444 6.00016 4 6.00016C4.25556 6.00016 4.5 6.04739 4.73333 6.14183C4.96667 6.23627 5.17778 6.36683 5.36667 6.5335L10.0667 3.80016C10.0444 3.7335 10.0278 3.6585 10.0167 3.57516C10.0056 3.49183 10 3.41127 10 3.3335C10 2.77794 10.1944 2.30572 10.5833 1.91683C10.9722 1.52794 11.4444 1.3335 12 1.3335C12.5556 1.3335 13.0278 1.52794 13.4167 1.91683C13.8056 2.30572 14 2.77794 14 3.3335C14 3.88905 13.8056 4.36127 13.4167 4.75016C13.0278 5.13905 12.5556 5.3335 12 5.3335C11.7444 5.3335 11.5 5.28627 11.2667 5.19183C11.0333 5.09739 10.8222 4.96683 10.6333 4.80016L5.93333 7.5335C5.95556 7.60016 5.97222 7.67516 5.98333 7.7585C5.99444 7.84183 6 7.92239 6 8.00016C6 8.07794 5.99444 8.1585 5.98333 8.24183C5.97222 8.32516 5.95556 8.40016 5.93333 8.46683L10.6333 11.2002C10.8222 11.0335 11.0333 10.9029 11.2667 10.8085C11.5 10.7141 11.7444 10.6668 12 10.6668C12.5556 10.6668 13.0278 10.8613 13.4167 11.2502C13.8056 11.6391 14 12.1113 14 12.6668C14 13.2224 13.8056 13.6946 13.4167 14.0835C13.0278 14.4724 12.5556 14.6668 12 14.6668ZM12 4.00016C12.1889 4.00016 12.3472 3.93627 12.475 3.8085C12.6028 3.68072 12.6667 3.52239 12.6667 3.3335C12.6667 3.14461 12.6028 2.98627 12.475 2.8585C12.3472 2.73072 12.1889 2.66683 12 2.66683C11.8111 2.66683 11.6528 2.73072 11.525 2.8585C11.3972 2.98627 11.3333 3.14461 11.3333 3.3335C11.3333 3.52239 11.3972 3.68072 11.525 3.8085C11.6528 3.93627 11.8111 4.00016 12 4.00016ZM4 8.66683C4.18889 8.66683 4.34722 8.60294 4.475 8.47516C4.60278 8.34739 4.66667 8.18905 4.66667 8.00016C4.66667 7.81127 4.60278 7.65294 4.475 7.52516C4.34722 7.39739 4.18889 7.3335 4 7.3335C3.81111 7.3335 3.65278 7.39739 3.525 7.52516C3.39722 7.65294 3.33333 7.81127 3.33333 8.00016C3.33333 8.18905 3.39722 8.34739 3.525 8.47516C3.65278 8.60294 3.81111 8.66683 4 8.66683ZM12 13.3335C12.1889 13.3335 12.3472 13.2696 12.475 13.1418C12.6028 13.0141 12.6667 12.8557 12.6667 12.6668C12.6667 12.4779 12.6028 12.3196 12.475 12.1918C12.3472 12.0641 12.1889 12.0002 12 12.0002C11.8111 12.0002 11.6528 12.0641 11.525 12.1918C11.3972 12.3196 11.3333 12.4779 11.3333 12.6668C11.3333 12.8557 11.3972 13.0141 11.525 13.1418C11.6528 13.2696 11.8111 13.3335 12 13.3335Z"
        fill="#004949"
      />
    </g>
  </svg>
)

const VideoTalentCard = ({
  username = '',
  status = '',
  statusName = '',
  videoUrl = '',
  videoId = null,
  talentId = null,
  talen_skills = [],
  description,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const totalElementsToShow = 3
  const showSkills = talen_skills?.length > totalElementsToShow
  const elementsToShow = talen_skills?.slice(0, totalElementsToShow)

  const [rating, setRating] = useState(0)

  const {
    mutate: updateTalentStatusHutritClubMutate,
    isLoading: isLoadingUpdateTalentStatusHutritClub,
  } = useMutation(
    ['update-talent-status-hutrit-club'],
    updateTalentStatusHutritClub,
    {
      onSuccess: ({ status }) => {
        if (status === 500) {
          Toast({ title: t('error_in_the_system'), icon: 'error' })
        }

        if (status === 200) {
          queryClient.invalidateQueries('list-video-talents-from-master')
          Toast({
            title: '¡Aprobado/rechazado correctamente!',
          })
        }
      },
    }
  )

  const handleUpdateTalentStatus = ({ visible, rejected }) => {
    updateTalentStatusHutritClubMutate({
      videoId,
      talentId,
      visible,
      rejected,
    })
  }

  const handleShareTalent = () => {
    Toast({ title: '¡talento copiado correctamente!' })
    copyClipboard(
      `${window.location.origin}/hutrit-club-talent-detail/${talentId}`
    )
  }

  const renderStatusStyles = {
    active: {
      container: 'border border-on-bg-success text-on-bg-success fontSize10',
      icon: <CheckIcon fill="#157A08" width="12px" height="12px" />,
    },
    desactivate: {
      container: 'border border-on-bg-danger text-on-bg-danger fontSize10',
      icon: <Xicon fill="#EA3D29" width="12px" height="12px" />,
    },
  }

  const renderSkills = (
    <div className="d-flex align-items-baseline overflow-auto mt-2">
      {elementsToShow.map(({ skills_categori, id }) => (
        <Badge
          key={id}
          className="border border-on-bg-CTA-primary-selected text-on-bg-CTA-primary-selected rounded-pill me-2 font-small-3"
        >
          {skills_categori?.skill?.name || NOT_AVAILABLE}
        </Badge>
      ))}
      {showSkills && (
        <Badge
          key={talentId}
          className="bg-bg-CTA-complementary-pressed  text-on-bg-primary rounded-pill me-2 font-small-3"
        >
          {`+${Number(talen_skills?.length) - Number(totalElementsToShow)}`}
        </Badge>
      )}
    </div>
  )

  const renderMasterFooterView = (
    <div className="d-flex justify-content-between">
      <div className="d-flex align-items-center gap-1 cursor-pointer">
        <span className="fontSize12 inline-text text-on-bg-primary">
          Ver video
        </span>
        <OpenTabIcon fill="#004949" />
      </div>
      <div className="d-flex align-items-center gap-2">
        <Button
          className="border border-text-on-bg-primary bg-white p-2"
          onClick={() =>
            handleUpdateTalentStatus({
              visible: false,
              rejected: true,
            })
          }
        >
          {isLoadingUpdateTalentStatusHutritClub ? (
            <Loader />
          ) : (
            <span className="fontSize14 text-on-bg-primary">
              {t('decline')}
            </span>
          )}
        </Button>
        <Button
          className="btn-bg-CTA-primary text-on-bg-primary p-2 fontSize14s"
          onClick={() =>
            handleUpdateTalentStatus({
              visible: true,
              rejected: false,
            })
          }
        >
          {isLoadingUpdateTalentStatusHutritClub ? (
            <Loader />
          ) : (
            <span className="fontSize14 text-on-bg-primary">
              {t('approve')}
            </span>
          )}
        </Button>
      </div>
    </div>
  )

  const renderPublicFooterView = (
    <div className="d-flex justify-content-between fontSize14">
      <Button
        className="btn-bg-white text-on-bg-primary border border-on-bg-primary"
        onClick={() =>
          openNewTab({
            url: OUT_OF_THE_APP
              ? '/register-company'
              : 'https://calendly.com/hutrit/hutrit-club',
          })
        }
      >
        {t('contact')}
      </Button>
      <Button
        className="btn-bg-white text-on-bg-primary border border-on-bg-primary"
        onClick={handleShareTalent}
      >
        {shareIcon}
      </Button>

      {IS_COMPANY && (
        <Button
          className="btn-bg-white text-on-bg-primary border border-on-bg-primary"
          onClick={() =>
            navigate(`/hutrit-club-talent-detail-video/${talentId}`)
          }
        >
          Ver Detalles
        </Button>
      )}
    </div>
  )

  const renderDescription = (
    <div
      className="text-on-bg-primary fontSize12 h-100 w-100"
      style={{
        lineHeight: '14px',
        maxHeight: '100px',
        overflow: 'auto',
      }}
    >
      {description}
    </div>
  )

  return (
    <div
      className="rounded shadow-sm border px-3 py-2"
      style={{
        width: '309px',
        height: OUT_OF_THE_APP || IS_COMPANY ? '400px' : '',
      }}
    >
      <div
        className="h-100"
        style={{
          display: 'grid',
        }}
      >
        <div className="d-flex justify-content-between overflow-auto">
          <div className="text-on-bg-primary d-flex flex-column align-items-start">
            <div className="d-flex align-items-end gap-3">
              <div className="fontSize20 fw-bold">
                {username === '' ? 'No disponible' : username}
              </div>
              {/* {IS_COMPANY && <StarRating value={rating} onChange={setRating} />} */}
            </div>
            {(OUT_OF_THE_APP || IS_COMPANY) && renderSkills}
            {IS_ADMIN && (
              <div className="d-flex align-items-center gap-2">
                <Link
                  className="text-underline fontSize12 text-on-bg-primary"
                  to={`/hutrit-club-talent-detail-video/${talentId}`}
                >
                  <span>{t('view_profile')}</span>
                  <ArrowRightIcon fill="#004949" />
                </Link>
              </div>
            )}
          </div>
          {IS_ADMIN && (
            <div
              className={`${renderStatusStyles?.[status]?.container} px-2 py-1 d-flex align-items-center gap-0`}
              style={{
                borderRadius: '12px',
                height: 'max-content',
              }}
            >
              <span> {renderStatusStyles?.[status]?.icon}</span>
              <span className="fontSize10"> {statusName}</span>
            </div>
          )}
        </div>
        <Divider className="w-100 h-1 bg-on-bg-primary mb-1 mt-2" />
        {renderDescription}
        <video controls className="rounded mb-1" width="280px" height="150px">
          <source src={videoUrl} type="video/mp4" />
          Tu navegador no soporta videos.
        </video>
        {IS_ADMIN && renderMasterFooterView}
        {(OUT_OF_THE_APP || IS_COMPANY) && (
          <div className="d-flex flex-column gap-3">
            {renderPublicFooterView}
          </div>
        )}
      </div>
    </div>
  )
}

export default VideoTalentCard
